/*
 * @Author: AnNa
 * @Date: 2021-04-24 09:31:09
 * @LastEditors: AnNa
 * @LastEditTime: 2021-08-12 13:48:43
 * @Description:
 */
import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN } from '@/store/mutation-types'

// 创建 axios 实例
// http://192.168.0.198/api
// https://yun-api.nianchu.net/api
// https://yun-api95d.nianchu.net:9991/api
// http://cloud_test.nianchu.net/api
// process.env.NODE_ENV === 'develop'
// console.log(process.env)
// const prefix = 'http://192.168.3.52/api'
// process.env.NODE_ENV === 'development' ? 'http://cloud_test.nianchu.net/api' : 'https://cloudmanage.nianchu.net/api'
// 正式地址
//  const prefix = 'https://cloudmanage.nianchu.net/api' //弃用
// const prefix = 'https://service-1l7k0ih9-1301483065.bj.apigw.tencentcs.com/api' // 2022-10-31-23:00废掉
const prefix = 'https://cloudmanage.nianchu.net/api'
// const prefix = 'http://cloudmanage.nianchu.net/api'

//菜鸟工具
const rookie_prefix = 'http://121.4.140.15/api'

// 测试地址
// const prefix = 'http://cloud_test.nianchu.net/api'

// 刘聪的ip地址
// const prefix = 'http://192.168.110.66:80/api'


const service = axios.create({
  baseURL: prefix, // api base_url
  rookieBaseURL:rookie_prefix,//api rookieBaseURL
  timeout: 200000 // 请求超时时间
})
const err = error => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }

    if (error.response.status === 401) {
      notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
  }
  notification.error({
    message: '请求失败',
    description: '网络繁忙，请稍后再试！'
  })
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  config.headers['version'] = 'v3.0'
  const token = Vue.ls.get(ACCESS_TOKEN)
  const GoogleAuthMark = Vue.ls.get('GoogleAuthMark')
  //const RookieToken = Vue.ls.get('RookieToken')
  if (token) {
    config.headers['user-token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
	//config.headers['rookie-token'] = RookieToken
    // if (config.baseURL === prefix) {
    config.headers['google-auth-mark'] = GoogleAuthMark
    config.headers['oem'] = store.state.brand.domain ? store.state.brand.domain : ''
    // }
  }
  // switch (config.urlType) {
	 //  case 'api1':
		//   config.url = baseURL + config.url;
		//   break;
	 //  case 'api2':
		//   config.url = rookieBaseURL + config.url;
		//   break;
	 //  default:
		//   config.url = baseURL + config.url;
  // }
  return config
}, err)

// response interceptor
service.interceptors.response.use(response => {
  if (response.data.code == 20025) {
    store.dispatch('googleauthUpdateStatus', {
      status: true
    })
  } else if (response.data.code === -14) {
    notification.error({
      message: '请求失败',
      description: '用户登录失效，请重新登录'
    })
  }

  return response.data
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export { installer as VueAxios, service as axios }
